export const EXPLORE_RESPONSE_PAGE_SIZE = 50;

const GROUPING_LIMIT = 8;

function buildFrontEndPath(portfolioId, companyId, rewardPeriod, groupings = [], pageNumber) {
    let result = `/our-programme/portfolio/${portfolioId}`;
    if (companyId)
        result += `/company/${companyId}`;
    if (rewardPeriod)
        result += `/period/${rewardPeriod.periodBasis}/${rewardPeriod.startDate}`;
    const groupingsSpecified = groupings.filter(it => it && it.length > 0);
    if (groupingsSpecified.length > 0)
        result += `/explore/${groupingsSpecified.join("/")}`;
    if (pageNumber)
        result += `/page/${pageNumber}`;
    return result;
}

function buildBackEndPath(portfolioId, companyId, rewardPeriod, limit, suffix, queryParams) {
    let result = `/ui/api/performance/portfolio/${portfolioId}`;
    if (companyId)
        result += `/company/${companyId}`;
    if (rewardPeriod)
        result += `/period/${rewardPeriod.periodBasis}/${rewardPeriod.startDate}`;
    if (limit)
        result += `/limit/${limit}`;
    if (suffix)
        result += `/${suffix}`;
    if (queryParams) {
        const queryString = Object.entries(queryParams).map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join("&");
        result += `?${queryString}`;
    }
    return result;
}

function rewardPeriod(rewardPeriodBasis, rewardPeriodStartDate) {
    if (rewardPeriodBasis && rewardPeriodStartDate)
        return {periodBasis: rewardPeriodBasis, startDate: rewardPeriodStartDate};
    else
        return null;
}

export function subscriptionUrl({companyId, rewardPeriodBasis, rewardPeriodStartDate, portfolioId}) {
    return buildBackEndPath(portfolioId, companyId, rewardPeriod(rewardPeriodBasis, rewardPeriodStartDate), GROUPING_LIMIT);
}

export function exploreSubscriptionUrl({companyId, rewardPeriodBasis, rewardPeriodStartDate, portfolioId, firstGroupingName, secondGroupingName, pageNumber = 1}, filter) {
    const queryParams = {};
    if (firstGroupingName)
        queryParams.firstGroup = firstGroupingName;
    if (secondGroupingName)
        queryParams.secondGroup = secondGroupingName;
    queryParams.pageLimit = EXPLORE_RESPONSE_PAGE_SIZE;
    queryParams.pageNumber = pageNumber;
    if (filter)
        queryParams.search = filter;

    return buildBackEndPath(portfolioId, companyId, rewardPeriod(rewardPeriodBasis, rewardPeriodStartDate), null, "customGrouping", queryParams);
}

export default class OurProgrammeContext {
    constructor({portfolioId, rewardPeriodBasis, rewardPeriodStartDate, companyId = null, firstGroupingName = null, secondGroupingName = null}, portfolioName = null, companyWithinPortfolioName = null, selectedPeriod) {
        this.portfolioId = portfolioId;
        this.requestedPeriod = rewardPeriod(rewardPeriodBasis, rewardPeriodStartDate);
        this.companyWithinPortfolioId = companyId;
        this.firstGroupingName = firstGroupingName;
        this.secondGroupingName = secondGroupingName;
        this.portfolioName = portfolioName;
        this.companyWithinPortfolioName = companyWithinPortfolioName;
        this.selectedPeriod = selectedPeriod;
    }

    context() {
        const {periodBasis, startDate} = this.selectedPeriod;
        return {
            portfolioId: this.portfolioId,
            portfolioName: this.portfolioName,
            companyWithinPortfolioId: this.companyWithinPortfolioId,
            companyWithinPortfolioName: this.companyWithinPortfolioName,
            periodBasis,
            startDate,
            firstGroupingName: this.firstGroupingName,
            secondGroupingName: this.secondGroupingName
        };
    }

    exploreGroupingHref(groupName) {
        return buildFrontEndPath(this.portfolioId, this.companyWithinPortfolioId, this.requestedPeriod, [groupName]);
    }

    secondaryGroupingPath(secondGroupingName) {
        return buildFrontEndPath(this.portfolioId, this.companyWithinPortfolioId, this.requestedPeriod, [this.firstGroupingName, secondGroupingName]);
    }

    explorePagePath(pageNumber) {
        return buildFrontEndPath(this.portfolioId, this.companyWithinPortfolioId, this.requestedPeriod, [this.firstGroupingName, this.secondGroupingName], pageNumber);
    }

    portfolioOverviewPath() {
        return buildFrontEndPath(this.portfolioId, this.companyWithinPortfolioId, this.requestedPeriod);
    }

    companyWithinPortfolioOverviewPath(companyWithinPortfolioId) {
        return buildFrontEndPath(this.portfolioId, companyWithinPortfolioId, this.requestedPeriod);
    }

    wholePortfolioPath() {
        return buildFrontEndPath(this.portfolioId, null, this.requestedPeriod);
    }

    periodPath(periodBasis, startDate) {
        return buildFrontEndPath(this.portfolioId, this.companyWithinPortfolioId, { periodBasis, startDate }, [this.firstGroupingName, this.secondGroupingName]);
    }

    isSelectedPeriod(periodBasis, startDate) {
        return this.selectedPeriod.periodBasis === periodBasis && this.selectedPeriod.startDate === startDate;
    }

    exportGroupingHref(groupingName) {
        return buildBackEndPath(this.portfolioId, this.companyWithinPortfolioId, this.requestedPeriod, null, "export", {firstGroup: groupingName});
    }
}
